export default [
  {
    path: "user-session",
    component: () =>
      import(
        "@/pages/EntityManagementPages/UserSessionManagementPages/UserSessionListPage"
      ),
  },
];
